import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// English uses key === value, so we keep it as a static bundled resource.
// Arabic is loaded from the backend API so admin edits take effect without a rebuild.
import translationEN from './locales/en-flat.json';

i18n
  .use(HttpBackend) // Load Arabic translations from backend
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    // English is bundled statically (key === value, never edited by admin)
    resources: {
      en: { translation: translationEN },
    },

    // Only Arabic needs to be fetched from the backend
    partialBundledLanguages: true,

    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    backend: {
      loadPath: '/api/v1/admin/customer/translations/web/',

      // No auth required — public endpoint, no browser cache on reload
      customHeaders: {},
      withCredentials: false,
      requestOptions: { cache: 'no-store' },

      // The API returns { data: [{ key, value }, ...] } — convert to flat { key: value } map
      parse: (data) => {
        const json = JSON.parse(data);
        const items = json.data || json;
        if (Array.isArray(items)) {
          const result = {};
          for (const item of items) {
            result[item.key] = item.value;
          }
          return result;
        }
        return items;
      },
    },

    react: {
      useSuspense: false, // Disable suspense to avoid issues
      bindI18n: 'languageChanged loaded', // Re-render when translations finish loading from backend
    },

    // Use the key as fallback if translation is missing
    returnNull: false,
    returnEmptyString: false,
  });

export default i18n;
